// @flow
import { combineReducers } from 'redux';
import gradPrograms from './gradPrograms';
import type { Action as GradProgramsAction } from '../../actions/gradSchools/gradPrograms';

export default combineReducers<
  {
    gradPrograms: typeof gradPrograms
  },
  GradProgramsAction
>({ gradPrograms });
